
import { useBrokerProfile } from './broker/use-broker-profile';
import { useLinkedUsers } from './broker/use-linked-users';
import { useBrokerLink } from './broker/use-broker-link';
import { BrokerProfile, LinkedUser, LinkResult } from '@/types/broker.types';

export type { BrokerProfile, LinkedUser, LinkResult };

export const useBroker = () => {
  const { brokerProfile, isLoading: isProfileLoading, updateBrokerProfile } = useBrokerProfile();
  const { linkedUsers, isLoading: isUsersLoading } = useLinkedUsers();
  const { 
    linkedBroker, 
    referralCode, 
    setReferralCode, 
    linkToBroker,
    unlinkBroker,
    isLinking,
    isUnlinking,
    isLoading: isLinkLoading,
    hasError
  } = useBrokerLink();
  
  const isLoading = isProfileLoading || isUsersLoading || isLinkLoading;
  
  return {
    // Broker profile data
    brokerProfile,
    updateBrokerProfile,
    
    // Linked users data
    linkedUsers,
    
    // Broker linking data
    linkedBroker,
    referralCode,
    setReferralCode,
    linkToBroker,
    unlinkBroker,
    isLinking,
    isUnlinking,
    hasError,
    
    // Common
    isLoading
  };
};
